<template>
    <div class="bindWechat">
        <div class="content-top">
            <h1>请先扫码新增账号</h1>
            <h4>您还没有管理员和财务账号！为了您的资金、信息安全，请先使用微信扫码在手机端新增管理员、财务账号后再进行资金对账等操作！</h4>
            <h3>
                <i class="el-icon-warning" style="color:rgba(24, 144, 255, 1);margin-right:10px"></i>
                为确保账户安全，请使用微信扫描下方二维码，绑定账号
            </h3>
            <img src="../assets/er.png" alt="">
        </div>
        <div class="tips">
            <p style="color:rgba(166, 166, 166, 1);font-size:18px">说明</p>
            <p>为提升账号安全，需要使用 <span>技术员或管理人员</span> 微信扫码绑定！</p>
            <p>绑定后，可快捷扫码登陆，而且可在手机端进行管理操作。</p>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped lang='stylus'>
.bindWechat{
    .content-top{
        text-align center
        h1,h4,h3{
            margin 20px auto
        }
        h1{
            font-weight bold
            font-size 33px
        }
        h4{
            color rgba(0, 0, 0, 0.45)
            font-size 14px 
        }
        h3{
            width 470px
            height 40px
            background rgba(230, 247, 255, 1)
            border 1px solid rgba(145, 213, 255, 1)
            padding 0 20px
            line-height 40px
            color rgba(0, 0, 0, 0.65)
        }
        img{
            width 310px
            height 310px
            margin-bottom 50px
        }
    }
    .tips{
        padding 10px 0 10px 50px
        border-top 1px solid  #eee 
        p{
            margin-top 15px
            span{
                color rgba(212, 48, 48, 1)
                font-size 16px
                font-weight bold 
            }
        }
    }


}

</style>